import ConfirmationModalBase from "@/components/common/modals/confirmation-modal-base";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  isLoading?: boolean;
}

const DeleteNotificationModal = ({
  isOpen,
  onClose,
  onAccept,
  isLoading = false,
}: Props) => {
  return (
    <ConfirmationModalBase
      isOpen={isOpen}
      onClose={onClose}
      onAccept={onAccept}
      title="Eliminar notificación"
      description="¿Estás seguro de que deseas eliminar esta notificación?"
      acceptText="Eliminar notificación"
      acceptVariant="danger-secondary"
      isLoading={isLoading}
    />
  );
};

export default DeleteNotificationModal;
